import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { ThemeProvider } from './context/ThemeContext';
import i18n from './i18n';
import { queryClient } from './lib/query-client';
import { router } from './router';

/**
 * Provider tree for the web app.
 *
 * Order matters:
 *   - QueryClientProvider must wrap anything that calls useQuery
 *   - I18nextProvider must wrap anything that calls useTranslation
 *   - ThemeProvider wraps everything so Toaster/Radix see the theme class
 *   - RouterProvider is the innermost so route components can consume all of the above
 *
 * AuthContext (PEL-818) slots between ThemeProvider and RouterProvider.
 */
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider>
          <RouterProvider router={router} />
          <Toaster position="top-center" richColors closeButton />
        </ThemeProvider>
      </I18nextProvider>
      {import.meta.env.DEV ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
}
